import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject } from "rxjs";
import { Vehicle } from '../models/Vehicle';

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  private _vehicle = new BehaviorSubject<Vehicle>(null);
  readonly vehicle = this._vehicle.asObservable();
  private dataStore: { selectedVehicle:Vehicle} = {selectedVehicle:null};

constructor() { }

images = [

]; 

fetchImages(): Observable<any> {
  return of(this.images);
}

updateVehicleImage(branch){
  this.dataStore.selectedVehicle = branch;
    this._vehicle.next(Object.assign({}, this.dataStore).selectedVehicle);
}

}

